<!--
================================================
Un composant affichant un spinner loader

Permet de signaler à l'utilisateur que des actions asynchrones sont en cours.
Le loader a été créé sur : https://loading.io/spinner/custom/208796/

* si loadingTxt est fourni alors son contenu s'affichra en dessous de l'image

================================================
-->


<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
   <div class="spinner spinnerLoaderComp" v-bind:class="{'darkMode':themeToDisplay=='dark'}">
       <img src="../assets/img/loader.svg" v-bind:alt="$t('chargement')" width="90">
       <div v-if="loadingTxt !=null" class="loadingTxt">{{ loadingTxt}}</div>
   </div>
</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->


<script>
    import {mapState} from 'vuex'

    export default {
        name: 'SpinnerLoaderComp',
        // mixins: [],
        // components: {},


        props: {
          // si non null alors le texte fourni s'affichera en plus de l'image du loader
          loadingTxt: {
            type: String,
            required: false,
            default: null,
          },
        },

        data: function () {
            return {}
        },
        computed: ({

          ...mapState({
            // user: state => state.user,
            themeToDisplay: state => state.app.themeToDisplay
          }),

        }),

        // LIFECYCLE HOOKS (https://v2.vuejs.org/v2/guide/instance.html#Lifecycle-Diagram)
        mounted: function () {
        }
    }
</script>

<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import "../assets/css/globalVar.scss";

    .spinnerLoaderComp{

      //////////////////////////////////////////
      // LIGHT THEME ///////////////////////////

      padding: 1rem;
      color:#ccc; font-weight: bold;
      .loadingTxt{
      }



      /////////////////////////////////////////
      // DARK THEME ///////////////////////////
      &.darkMode {
      }
    }

</style>
